export enum LessonStatusEnum {
    Pending = 1,
    Confirmed= 2,
    Rejected = 3,
    CancelledChargeable = 4,
    CancelledNotChargeable = 5,
    Removed = 6 ,
    Disputed = 7
   
}